import React from 'react'
import logo from '../media/YI_logo_b_w.jpg'
const Dashboard = () => {
  return (
    <div>
      <img src={logo} alt='Yaari Infinity'height="50%" width="50%" align="center"/>
    </div>
  )
}

export default Dashboard